import { Injectable } from '@angular/core';

import { RcsConnectorOdooProvider } from '../rcs-connector-odoo/rcs-connector-odoo';
import { RcsStackDbProvider } from '../rcs-stack-db-service/rcs-stack-db-service';
import {StackPrototyp, TaskPrototyp} from "./stack.prototyp";
import {BehaviorSubject, AsyncSubject, Observable, Subject} from "rxjs";
import {DraftServiceProvider} from "../draft-service/draft-service";
import { JobPrototyp } from '../../assets/shared/job.object';
import { RcsConnectorIndexDbProvider } from '../rcs-connector-index-db/rcs-connector-index-db';

@Injectable()
export class StackService{

  public observer: BehaviorSubject<any> = new BehaviorSubject(false);
  public job_observer: Subject<any> = new Subject();
  private is_running: Boolean;
  private network_state: Boolean = false;
  private sync_count: number;
  private ctn: number;

  constructor(
    private odoo_service: RcsConnectorOdooProvider,
    private db_service: RcsConnectorIndexDbProvider,
    private db: RcsStackDbProvider,
    private draft: DraftServiceProvider){
      this.network_state = (Boolean)(localStorage.getItem('online_status') || false);
      this.ctn=1;
    }

  public getNetworkState():Boolean {
    return this.network_state;
  }

  public setNetworkState(state: Boolean) {
    console.log("STACK SET NETWORK STATE");
    /*if(this.ctn == 0) {
      console.log("INIT");
      this.ctn = 1;
      let self = this;
      setTimeout(function(){
        console.log("INIT Done");
        self.add(815, 1, 'add', null);
        self.add(815, 2, 'add', null);
        self.add(816, 1, 'add', null);
        self.add(816, 3, 'add', null);
      }, 10000);
    }*/

    this.network_state = state;
    localStorage.setItem('online_status', (String)(state));
  }

  // Fügt einen Task zum Stack hinzu
  public add(job_id: number, id:number, method:string, params:Array<any>):void{
    let task = new TaskPrototyp(id, method, params);
    this.db.search('stack', job_id).subscribe((result) => {
      if (result){
        result.tasks[id] = task;
        this.db.update(result, job_id).subscribe(() => {
          this.running();
        });
      }else{
        const prototyp = new StackPrototyp(job_id, {[id]: task});
        this.db.add(prototyp, job_id).subscribe(() => {
          this.running();
        })
      }
    })
  }

  // Tasks werden nacheinander abgearbeitet
  public running():void{
    // return;
    if (!this.is_running) {
      this.is_running = true;
      this.sync_count = 0;
      this.db.get_tasks().subscribe(results => {
        if (results.length) {
          console.log("START STACK", results.length);
        } else {
          this.is_running = false;
        }
        if (results){
          for (const result of results){
            this.sync_count++;
            this.execute(result);
            // console.log(result);
          }
          // console.log(this.is_running);
        }
      },
      error => {
        console.log("A", error);
      })
    } else {
      console.log('STACK IS ALREADY RUNNING');
    }
  }

  private decrementCounter() {
    this.sync_count--;
    console.log(this.sync_count);
    if (this.sync_count <= 0) {
      this.is_running = false;
      console.log(this.sync_count, this.is_running);
    }
  }

  // private execute2(stack_object) {
  //   setTimeout(() => { this.decrementCounter(); }, 1000);
  // }

  // Führt die Bearbeitung und Speicherung der Task Resultate aus
  private execute(stack_object) {
    if ( this.getNetworkState() && (stack_object && stack_object['tasks'] != undefined)) {
      const key = Object.keys(stack_object.tasks)[0]
      if (this.odoo_service[stack_object.tasks[key].method]) {
        this.odoo_service[stack_object.tasks[key].method].apply(this.odoo_service, stack_object.tasks[key].params).subscribe(
          response => {
            console.log("STACK:", response);
            if (response.json().error) {
              if (key === '1' && stack_object.tasks[key].calls < 5) {
                console.log("Ersatzteilelieferung not done", stack_object.tasks[key].calls);
                stack_object.tasks[key].calls += 1
                this.db.update(stack_object, stack_object.id).subscribe(() => {
                  setTimeout(() => {
                    this.execute(stack_object)
                  }, 5000);
                })
              } else if (key === '1' && stack_object.tasks[key].calls >= 5) {
                stack_object.tasks[key].calls = 0
                this.db.update(stack_object, stack_object.id).subscribe(() => {
                  this.observer.next(stack_object.id + '_' + 0);
                  this.decrementCounter();
                  console.error("ODOO SYNC FEHLER:", response.json().error);
                })
              } else {
                this.observer.next(stack_object.id + '_' + 0);
                this.decrementCounter();
                console.error("ODOO SYNC FEHLER:", response.json().error);
              }
            }else{
              this.observer.next(stack_object.id + '_' + stack_object.tasks[key].id)
              delete stack_object.tasks[key]

              if (Object.keys(stack_object.tasks).length > 0) {
                this.db.update(stack_object, stack_object.id).subscribe(() => {
                  this.execute(stack_object)
                })
              }

              if (Object.keys(stack_object.tasks).length == 0) {
                console.log("JOB2 STACK START")
                this.update_job2(stack_object).subscribe((job) => {
                  setTimeout(() => {
                    console.log("JOB2 STACK RESOLVE", job);
                    this.job_observer.next(job);
                  }, 1500);
                });
                this.draft.delete(stack_object.id, key);
                this.db.remove_stack_item(stack_object.id);
                this.decrementCounter();
              }
            }},
          error => {
            console.log("ERR", error);
            this.observer.next(stack_object.id + '_' + 0);
            this.setNetworkState(false);
            this.decrementCounter();
          },
          () => {
            console.log('test')
            // this.observer.next(stack_object.id + '_' + 0);
          })
      }
    } else {
      this.decrementCounter();
      this.observer.next('network offline - stop stack.execute')
    }
  }

  private update_job2(current_job):AsyncSubject<any>{
    let prototyp = new JobPrototyp();
    let result_guardian = new AsyncSubject();

    this.db_service.get_record_by_key('login', 'user_login').subscribe(
      login => {
        if (this.getNetworkState()){
          this.odoo_service.get(login, prototyp, 'rcs.kdienst.auftrag', [["id", "=", current_job.id]], 0, 0, {"filter_my": 1}).subscribe(
            (response) => {
              let monteur_id = this.odoo_service.simple_search_read(login, 'rcs.kdienst.monteur', [["employee_id.login","=",login.username]], ["id"]);
              Observable.forkJoin.apply(this, [ response, monteur_id ]).subscribe( (data) => {
                console.log(data)
                let job = data[0]
                job['monteur'] = data[1].json().result[0];
                this.db_service.update_record('jobs', job, job.id).subscribe(
                  () => {
                    setTimeout(() => {
                      result_guardian.next(job);
                      result_guardian.complete();
                    }, 500);
                  }
                );
              });
            }
          )
        }else{
          this.db_service.update_record('jobs', current_job, current_job.id);
          result_guardian.next(current_job);
          result_guardian.complete();
        }
      }
    )
    return result_guardian;
  }
}



// WEBPACK FOOTER //
// ./src/providers/odoo/stack.service.ts